import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { getAuthorizedLpSelected } from "../../actions/lp";
import { GET_AUTHORIZED_LP_SELECTED_REQUEST } from "../../actions/lp/actionTypes";
export var getLpSelectedEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(GET_AUTHORIZED_LP_SELECTED_REQUEST), switchMap(function(action) {
        return from(api.clwsServices.getLpDetailsService().pipe(mergeMap(function(param) {
            var logisticsPartyDetails = param.logisticsPartyDetails;
            return of(getAuthorizedLpSelected.success(logisticsPartyDetails));
        }), catchError(function(err) {
            return of(getAuthorizedLpSelected.failure(err));
        })));
    }));
};
export default getLpSelectedEpic;

//# sourceMappingURL=getLpSelectedEpic.js.map